import React from "react";
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// @material-ui/icons

// core components
const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { ssr: true });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'), { ssr: true });
const Button = dynamic(() => import('/components/CustomButtons/Button.js'), { ssr: true });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";

const styles = {
  ...landingPage,
  container2: {
    "@media (min-width: 1200px)": {
      maxWidth: "1500px",
    },
  },
  actionbutton: {
    width: "100%",
    fontSize: "0.775rem",
    "@media (min-width: 1200px)": {
      width: "37%",
    },
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "550px",
    margin: "10px auto 0 0",
  },
}

const useStyles = makeStyles(styles);

import { getLangFromObj } from "lang/lang.js";

export default function HeaderSectionParallax({title, subTitle, action}) {
  const classes = useStyles();
  const { locale } = useRouter();

  if(typeof subTitle === "object")
  {
    subTitle = getLangFromObj(subTitle, locale);
  }

  if(typeof title === "object")
  {
    title = getLangFromObj(title, locale);
  }

  if(action !== false && action !== undefined && typeof action.text === "object")
  {
    action.text = getLangFromObj(action.text, locale);
  }

  let actionButton = (<></>);

  if(action !== false && action !== undefined)
  {
    if(action.type === "external")
      actionButton = (
        <Button
          color={action.color}
          size="lg"
          href={action.href}
          target="_blank"
          rel="noopener noreferrer"
          round
          className={classes.actionbutton}
          style={{fontSize:"0.775rem"}}
        >
          <FontAwesomeIcon icon={action.icon} size="lg" /> {" "}
          {action.text}
      </Button>
      );
    else
      actionButton = (
        <Button
          color={action.color}
          size="lg"
          href={action.href}
          round
          className={classes.actionbutton}
          style={{fontSize:"0.775rem"}}
        >
          <FontAwesomeIcon icon={action.icon} size="lg" /> {" "}
          {action.text}
      </Button>
      );
  }


  return (
    <div className={classNames(classes.container, classes.container2)}>
        <GridContainer style={{padding: "10px 30px"}} >
            <GridItem xs={12} sm={12} md={12}>
                <h1 id="page-title" className={classes.title}>{title}</h1>
                <h4 className={classes.subtitle}>
                    {subTitle}
                </h4>
                <br />
                {actionButton}
            </GridItem>
        </GridContainer>
    </div>
  );
}
